// Hard coded list of the top 100 Python packages in the last year
export default [
  'urllib3',
  'six',
  'botocore',
  'requests',
  'python-dateutil',
  'certifi',
  's3transfer',
  'idna',
  'docutils',
  'chardet',
  'pip',
  'setuptools',
  'pyyaml',
  'jmespath',
  'pyasn1',
  'rsa',
  'pytz',
  'boto3',
  'numpy',
  'awscli',
  'colorama',
  'wheel',
  'futures',
  'markupsafe',
  'protobuf',
  'jinja2',
  'simplejson',
  'cffi',
  'cryptography',
  'attrs',
  'click',
  'importlib-metadata',
  'pyasn1-modules',
  'future',
  'zipp',
  'pandas',
  'pyparsing',
  'cachetools',
  'pycparser',
  'oauthlib',
  'google-auth',
  'requests-oauthlib',
  'werkzeug',
  'decorator',
  'scipy',
  'packaging',
  'google-api-core',
  'wcwidth',
  'more-itertools',
  'grpcio',
  'googleapis-common-protos',
  'pytest',
  'jsonschema',
  'enum34',
  'google-cloud-core',
  'py',
  'pluggy',
  'pygments',
  'psutil',
  'flask',
  'pyjwt',
  'coverage',
  'scikit-learn',
  'pyrsistent',
  'itsdangerous',
  'wrapt',
  'pillow',
  'google-cloud-storage',
  'virtualenv',
  'ipaddress',
  'websocket-client',
  'pyopenssl',
  'sqlalchemy',
  'entrypoints',
  'google-resumable-media',
  'joblib',
  'lxml',
  'configparser',
  'prompt-toolkit',
  'asn1crypto',
  'ipython',
  'pexpect',
  'redis',
  'isodate',
  'httplib2',
  'matplotlib',
  'ptyprocess',
  'mock',
  'mccabe',
  'google-api-python-client',
  'boto',
  'tornado',
  'defusedxml',
  'beautifulsoup4',
  'tqdm',
  'docker',
  'traitlets',
  'tensorboard',
  'appdirs',
  'pycodestyle',
].sort()
